module.exports = __webpack_public_path__ + "img/cross_4.3258ce44.png";